import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

import type { DockTone } from "@/ai-coding-outputs/human-coding/auditDockModel";

type Counts = { highCount: number; mediumCount: number };

export type AuditEvent =
  | ({
      type: "finalise_check";
      encounterId: string;
      source: "background-result" | "server-check";
      dialogShown: boolean;
      dialogVisibleMs: number;
      waitMs: number;
      reachedDeepPhase: boolean;
      outcome: "clear" | "findings" | "screened-clear" | "failed" | "cancelled" | "skipped";
    } & Counts)
  | ({
      type: "finalise_findings_decision";
      encounterId: string;
      decision: "went-back" | "finalised-anyway";
      decisionMs: number;
      codesChangedSinceAudit: boolean;
    } & Counts)
  | ({
      type: "audit_result_ready";
      encounterId: string;
      tone: "clear" | "medium" | "high";
      checkMs: number;
      screened: boolean;
    } & Counts)
  | { type: "audit_peek_shown"; encounterId: string; highCount: number; newHighCount: number }
  | ({
      type: "audit_bar_opened";
      encounterId: string;
      trigger: "audit-half" | "notes-half" | "drag" | "peek";
      tone: DockTone;
    } & Counts)
  | {
      type: "audit_bar_closed";
      encounterId: string;
      trigger: "audit-half" | "notes-half" | "drag";
      openMs: number;
    }
  | {
      type: "finalise_confirmed";
      encounterId: string;
      tone: DockTone;
      highCount: number;
    };

const MAX_MS = 3_600_000;

export const clampMs = (ms: number): number =>
  Number.isFinite(ms) ? Math.min(MAX_MS, Math.max(0, Math.round(ms))) : 0;

export function trackAuditEvent(event: AuditEvent): void {
  try {
    fetchWithSupabaseAuth(`${QA_API_DOMAIN}/audit-events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(event),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Telemetry must never affect the UI.
  }
}
